import {Pipe, PipeTransform} from '@angular/core';
import {timeAgo} from 'src/app/domain/util/timestamps/timestamps';

@Pipe({
  name: 'toRelativeTime',
  standalone: true
})
export class ToRelativeTimePipe implements PipeTransform {

  public transform(value: string | Date | undefined): string {
    return timeAgo(value);
  }
}
